// Generated by Avo VERSION 177.30.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "RrjSp3lT9jrLSG0mgcZk";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "FKt8PmZdk6NWCwOlbUQj",
          "br": "Iv9tevMvR",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "0W1AhQECqKT8Mns7rnbu",
          "se": (new Date()).toISOString(),
          "so": "moO7WTdqJ",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "FKt8PmZdk6NWCwOlbUQj",
          "br": "Iv9tevMvR",
          "en": env,
          "ty": type,
          "sc": "0W1AhQECqKT8Mns7rnbu",
          "se": (new Date()).toISOString(),
          "so": "moO7WTdqJ",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "0W1AhQECqKT8Mns7rnbu",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export const StorePlatform = {
  'ANDROID_GOOGLE': 'ANDROID_GOOGLE',
  'ANDROID_HUAWEI': 'ANDROID_HUAWEI',
} as const;
export type StorePlatformType = typeof StorePlatform;
export type StorePlatformValueType = StorePlatformType[keyof StorePlatformType];

export const TravelSection = {
  'PRE_BOOK': 'PRE_BOOK',
  'PRE_SUMMARY': 'PRE_SUMMARY',
  'PRE_AUTHENTICATE': 'PRE_AUTHENTICATE',
  'POST_SEAMLESS_LOGIN': 'POST_SEAMLESS_LOGIN',
} as const;
export type TravelSectionType = typeof TravelSection;
export type TravelSectionValueType = TravelSectionType[keyof TravelSectionType];

export const Source = {
  'HOME': 'HOME',
  'STORE': 'STORE',
  'TRAVEL_HOME': 'TRAVEL_HOME',
  'FLIGHTS_HOME': 'FLIGHTS_HOME',
  'HOTELS_HOME': 'HOTELS_HOME',
  'BUSES_HOME': 'BUSES_HOME',
  'RESULTS': 'RESULTS',
  'DETAIL': 'DETAIL',
  'MAP': 'MAP',
  'LIST': 'LIST',
  'RESULTS_SCREEN': 'RESULTS_SCREEN',
  'DESTINATIONS': 'DESTINATIONS',
  'HOME_DETAIL': 'HOME_DETAIL',
  'USER_HISTORY': 'USER_HISTORY',
  'RESERVATIONS': 'RESERVATIONS',
  'TRAVEL_HISTORY': 'TRAVEL_HISTORY',
  'BOOKING': 'BOOKING',
  'ITINERARY': 'ITINERARY',
  'ORDER_SUMMARY': 'ORDER_SUMMARY',
  'CONTENT_DESCRIPTION': 'CONTENT_DESCRIPTION',
  'RECIPES_AISLE_DETAIL': 'RECIPES_AISLE_DETAIL',
  'RECIPES_SUB_AISLES': 'RECIPES_SUB_AISLES',
  'VERTICAL_SEARCH_CPGS': 'VERTICAL_SEARCH_CPGS',
  'VERTICAL_SEARCH_REST': 'VERTICAL_SEARCH_REST',
  'STORE_HOME': 'STORE_HOME',
  'SEARCH_QUICK_FILTERS': 'SEARCH_QUICK_FILTERS',
  'SEARCH_MODAL_FILTERS': 'SEARCH_MODAL_FILTERS',
  'ONTOP_MODAL': 'ONTOP_MODAL',
  'ONTOP_MODAL_PROGRESS': 'ONTOP_MODAL_PROGRESS',
  'VERTICAL_SEARCH_ECOM': 'VERTICAL_SEARCH_ECOM',
  'STORE_OFFERS_HOME': 'STORE_OFFERS_HOME',
  'TRY_AGAIN_MODAL': 'TRY_AGAIN_MODAL',
  'TRY_AGAIN': 'TRY_AGAIN',
  'CANCELLATION_SCREEN': 'CANCELLATION_SCREEN',
  'NULL_REDIRECT': 'NULL_REDIRECT',
  'SHARKS': 'SHARKS',
  'TRY_AGAIN_FULL_SCREEN': 'TRY_AGAIN_FULL_SCREEN',
  'BAD_REDIRECT': 'BAD_REDIRECT',
} as const;
export type SourceType = typeof Source;
export type SourceValueType = SourceType[keyof SourceType];

export const AppEnvironment = {
  'DEVELOPMENT': 'Development',
  'PRODUCTION': 'Production',
  'RELEASE': 'Release',
} as const;
export type AppEnvironmentType = typeof AppEnvironment;
export type AppEnvironmentValueType = AppEnvironmentType[keyof AppEnvironmentType];

let sysAppVersion: any;
let sysAppEnvironment: any;
let sysStorePlatform: any;

export function setSystemProperties(properties: {appVersion: string;
    appEnvironment: AppEnvironmentValueType;
    storePlatform: StorePlatformValueType | null | undefined}) {
if (properties.appVersion !== null && properties.appVersion !== undefined) {
  sysAppVersion = properties.appVersion;
}
if (properties.appEnvironment !== null && properties.appEnvironment !== undefined) {
  sysAppEnvironment = properties.appEnvironment;
}
if (properties.storePlatform !== null && properties.storePlatform !== undefined) {
  sysStorePlatform = properties.storePlatform;
}
}

let Firebase: any;
let Braze: any;
let Amplitude: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {appVersion: string;
    appEnvironment: AppEnvironmentValueType;
    storePlatform: StorePlatformValueType | null | undefined},
    destinationOptions: any,
    FirebaseDestination: CustomDestination,
    BrazeDestination: CustomDestination,
    AmplitudeDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

setSystemProperties(systemProperties);

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}

Firebase = FirebaseDestination;
if (__AVO_ENV__ === 'prod') {
  Firebase && Firebase.make && Firebase.make(__AVO_ENV__, "a");
} else if (__AVO_ENV__ === 'dev') {
  Firebase && Firebase.make && Firebase.make(__AVO_ENV__, "b");
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Firebase. Head to destination settings in Avo to set a staging key.");
  Firebase && Firebase.make && Firebase.make(__AVO_ENV__, null);
}

Braze = BrazeDestination;
if (__AVO_ENV__ === 'prod') {
  Braze && Braze.make && Braze.make(__AVO_ENV__, "a");
} else if (__AVO_ENV__ === 'dev') {
  Braze && Braze.make && Braze.make(__AVO_ENV__, "b");
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Braze. Head to destination settings in Avo to set a staging key.");
  Braze && Braze.make && Braze.make(__AVO_ENV__, null);
}

Amplitude = AmplitudeDestination;
if (__AVO_ENV__ === 'prod') {
  Amplitude && Amplitude.make && Amplitude.make(__AVO_ENV__, "gfgsdgeggs");
} else if (__AVO_ENV__ === 'dev') {
  Amplitude && Amplitude.make && Amplitude.make(__AVO_ENV__, "asdfsdf323234");
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Amplitude. Head to destination settings in Avo to set a staging key.");
  Amplitude && Amplitude.make && Amplitude.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface ViewTravelHomeProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  hasRappicard: boolean;
  source: SourceValueType;
  pageCode: string;
  branchCode: string;
}
/**
 * VIEW_TRAVEL_HOME: Views RappiTravel Home
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.hasRappicard: User has RappiCard
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.pageCode: Identifier code of a Travel page manage by its CMS
 * @param properties.branchCode: Branch where the search is taking place
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/adLiTMleeo}
 */
export function viewTravelHome(properties: ViewTravelHomeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "FAw_seLBQj", name: "HAS_RAPPICARD", value: properties.hasRappicard});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "D37LA0oeJe", name: "PAGE_CODE", value: properties.pageCode});
eventPropertiesArray.push({id: "DS2KOgrdcu", name: "BRANCH_CODE", value: properties.branchCode});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "adLiTMleeo", "0f0c05b7ebfcd63965c8568ac813482b97647c77fd848b04aedd21c6036dd9c5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_HOME", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("adLiTMleeo", "VIEW_TRAVEL_HOME", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_HOME", eventProperties, "adLiTMleeo", "0f0c05b7ebfcd63965c8568ac813482b97647c77fd848b04aedd21c6036dd9c5");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_HOME", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_HOME", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_HOME", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelPageProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  hasRappicard: boolean;
  source: SourceValueType;
  pageCode: string;
}
/**
 * VIEW_TRAVEL_PAGE: User views a destination page
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.hasRappicard: User has RappiCard
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.pageCode: Identifier code of a Travel page manage by its CMS
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/NN7raQT5n9}
 */
export function viewTravelPage(properties: ViewTravelPageProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "FAw_seLBQj", name: "HAS_RAPPICARD", value: properties.hasRappicard});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "D37LA0oeJe", name: "PAGE_CODE", value: properties.pageCode});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "NN7raQT5n9", "2d22a13cc31158af8f5b8013505a0b88a468e4c56bfc6607701fd23895dce185", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_PAGE", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("NN7raQT5n9", "VIEW_TRAVEL_PAGE", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_PAGE", eventProperties, "NN7raQT5n9", "2d22a13cc31158af8f5b8013505a0b88a468e4c56bfc6607701fd23895dce185");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_PAGE", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_PAGE", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_PAGE", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelSearchScreenProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  hasRappicard: boolean;
  source: SourceValueType;
  travelProductType: string;
  travelPlatform: string;
}
/**
 * VIEW_TRAVEL_SEARCH_SCREEN: Views the search screen
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.hasRappicard: User has RappiCard
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelPlatform: Detects user device platform for Travel, since Travel is a web view, the default platform from Amplitude is always set to web
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/aUg_onjBmg}
 */
export function viewTravelSearchScreen(properties: ViewTravelSearchScreenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "FAw_seLBQj", name: "HAS_RAPPICARD", value: properties.hasRappicard});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "NH57t3cmQ", name: "TRAVEL_PLATFORM", value: properties.travelPlatform});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "aUg_onjBmg", "7ce5714610d4ae82fe5ea9c400d2f253a5b2c0998dd812d40533835cad730b11", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_SEARCH_SCREEN", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("aUg_onjBmg", "VIEW_TRAVEL_SEARCH_SCREEN", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_SEARCH_SCREEN", eventProperties, "aUg_onjBmg", "7ce5714610d4ae82fe5ea9c400d2f253a5b2c0998dd812d40533835cad730b11");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_SEARCH_SCREEN", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_SEARCH_SCREEN", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_SEARCH_SCREEN", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelOrderConfirmedProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  hasRappicard: boolean;
  itineraryId: number;
  status: string;
  totalPrice: string;
  currency: string;
  daysTillTripStart: number;
  travelDestination: string;
  travelProductTypes: string;
  hotelCrossellDeeplink: string | null | undefined;
  travelProductProvider: string;
}
/**
 * TRAVEL_ORDER_CONFIRMED: Reservation was confirmed
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.hasRappicard: User has RappiCard
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.status: Travel Reservation Status
 * @param properties.totalPrice: Sum of the total price of the products minus discounts (markdown and global offers, excluding free delivery or service fee offers).
 * @param properties.currency: The currency of the value of the product in local values.
 * @param properties.daysTillTripStart: Number of days until the trip starts
 * @param properties.travelDestination: Destination of the trip
 * @param properties.travelProductTypes: no description
 * @param properties.hotelCrossellDeeplink: no description
 * @param properties.travelProductProvider: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/h77EFnUzgj}
 */
export function travelOrderConfirmed(properties: TravelOrderConfirmedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "FAw_seLBQj", name: "HAS_RAPPICARD", value: properties.hasRappicard});
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "4XUdCeDfht", name: "STATUS", value: properties.status});
eventPropertiesArray.push({id: "T5160UMNzL", name: "TOTAL_PRICE", value: properties.totalPrice});
eventPropertiesArray.push({id: "nWXSaAvcNS", name: "CURRENCY", value: properties.currency});
eventPropertiesArray.push({id: "3hllCdILP", name: "DAYS_TILL_TRIP_START", value: properties.daysTillTripStart});
eventPropertiesArray.push({id: "f6DM5S_j4", name: "TRAVEL_DESTINATION", value: properties.travelDestination});
eventPropertiesArray.push({id: "IgxN_z1PG", name: "TRAVEL_PRODUCT_TYPES", value: properties.travelProductTypes});
properties.hotelCrossellDeeplink !== undefined && properties.hotelCrossellDeeplink !== null ?
  eventPropertiesArray.push({id: "E0tFMhsga", name: "HOTEL_CROSSELL_DEEPLINK", value: properties.hotelCrossellDeeplink}) :
  eventPropertiesArray.push({id: "E0tFMhsga", name: "HOTEL_CROSSELL_DEEPLINK", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "h77EFnUzgj", "500e846f68432ba28e06ae4367a19c3fdf8af77bef83c8a072db657e7fd5b558", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_ORDER_CONFIRMED", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("h77EFnUzgj", "TRAVEL_ORDER_CONFIRMED", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_ORDER_CONFIRMED", eventProperties, "h77EFnUzgj", "500e846f68432ba28e06ae4367a19c3fdf8af77bef83c8a072db657e7fd5b558");
}
// destination Firebase
Firebase.logEvent("TRAVEL_ORDER_CONFIRMED", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_ORDER_CONFIRMED", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_ORDER_CONFIRMED", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectTravelSearchProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  source: SourceValueType;
}
/**
 * SELECT_TRAVEL_SEARCH: Search made on any of Travel products
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.source: Where the event was originated from - here: current context
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/c6eDNqlU1}
 */
export function selectTravelSearch(properties: SelectTravelSearchProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "c6eDNqlU1", "4e149c7b0e88a8e67032df53ab77234cde6904af782e70017a425bd3e8bf26b2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_TRAVEL_SEARCH", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("c6eDNqlU1", "SELECT_TRAVEL_SEARCH", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_TRAVEL_SEARCH", eventProperties, "c6eDNqlU1", "4e149c7b0e88a8e67032df53ab77234cde6904af782e70017a425bd3e8bf26b2");
}
// destination Firebase
Firebase.logEvent("SELECT_TRAVEL_SEARCH", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_TRAVEL_SEARCH", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_TRAVEL_SEARCH", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProceedToCheckoutProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string | null | undefined;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  source: SourceValueType;
  itineraryId: number;
}
/**
 * PROCEED_TO_CHECKOUT: Prepare to open checkout module
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.itineraryId: Travel Itinerary Id
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/9fAK4JI_JG}
 */
export function proceedToCheckout(properties: ProceedToCheckoutProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
properties.travelSearchId !== undefined && properties.travelSearchId !== null ?
  eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId}) :
  eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: null});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "9fAK4JI_JG", "3bf1ac7c8dd6348eeb7412aa8a2c22ca07fe8ce2862f1f025a9571217980dddd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("PROCEED_TO_CHECKOUT", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("9fAK4JI_JG", "PROCEED_TO_CHECKOUT", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PROCEED_TO_CHECKOUT", eventProperties, "9fAK4JI_JG", "3bf1ac7c8dd6348eeb7412aa8a2c22ca07fe8ce2862f1f025a9571217980dddd");
}
// destination Firebase
Firebase.logEvent("PROCEED_TO_CHECKOUT", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("PROCEED_TO_CHECKOUT", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("PROCEED_TO_CHECKOUT", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectCancellationConfirmProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  itineraryId: number;
}
/**
 * SELECT_CANCELLATION_CONFIRM: Click cancellation confirm button
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.itineraryId: Travel Itinerary Id
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/idFZEHH-G_}
 */
export function selectCancellationConfirm(properties: SelectCancellationConfirmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "idFZEHH-G_", "76dbf1999066d6409306ab8c7e44ef906f78fa6d36374bd6bb5919be962b509a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_CANCELLATION_CONFIRM", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("idFZEHH-G_", "SELECT_CANCELLATION_CONFIRM", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_CANCELLATION_CONFIRM", eventProperties, "idFZEHH-G_", "76dbf1999066d6409306ab8c7e44ef906f78fa6d36374bd6bb5919be962b509a");
}
// destination Firebase
Firebase.logEvent("SELECT_CANCELLATION_CONFIRM", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_CANCELLATION_CONFIRM", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_CANCELLATION_CONFIRM", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelResultsScreenProperties {
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string | null | undefined;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  source: SourceValueType;
  resultsCount: number;
  searchFlowType: string | null | undefined;
  travelSegment: string | null | undefined;
}
/**
 * VIEW_TRAVEL_RESULTS_SCREEN: Cada vez que vuelva a la pantalla inicial de resultados, pero no al filtrar los resultados, deberia disparar este evento, una vez recibido la respuesta de cantidad de resultados
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.resultsCount: no description
 * @param properties.searchFlowType: no description
 * @param properties.travelSegment: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/Tds23cedPX}
 */
export function viewTravelResultsScreen(properties: ViewTravelResultsScreenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
properties.travelSearchId !== undefined && properties.travelSearchId !== null ?
  eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId}) :
  eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: null});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "ehPCxLVCPZ", name: "RESULTS_COUNT", value: properties.resultsCount});
properties.searchFlowType !== undefined && properties.searchFlowType !== null ?
  eventPropertiesArray.push({id: "KE5TAKMZD7z44efMQfh58", name: "SEARCH_FLOW_TYPE", value: properties.searchFlowType}) :
  eventPropertiesArray.push({id: "KE5TAKMZD7z44efMQfh58", name: "SEARCH_FLOW_TYPE", value: null});
properties.travelSegment !== undefined && properties.travelSegment !== null ?
  eventPropertiesArray.push({id: "Z3sXe9jj7H-sdZpTLdBAi", name: "TRAVEL_SEGMENT", value: properties.travelSegment}) :
  eventPropertiesArray.push({id: "Z3sXe9jj7H-sdZpTLdBAi", name: "TRAVEL_SEGMENT", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Tds23cedPX", "f8a87e4fadb1e799dd1d20ed10df78fba625295e6716917b4c10be32826e5d98", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_RESULTS_SCREEN", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Tds23cedPX", "VIEW_TRAVEL_RESULTS_SCREEN", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_RESULTS_SCREEN", eventProperties, "Tds23cedPX", "f8a87e4fadb1e799dd1d20ed10df78fba625295e6716917b4c10be32826e5d98");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_RESULTS_SCREEN", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_RESULTS_SCREEN", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_RESULTS_SCREEN", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelReservationDetailProperties {
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  daysTillTripStart: number;
  source: SourceValueType;
  itineraryId: number;
  travelDestination: string;
  travelProductTypes: string;
  hotelCrossellDeeplink: string | null | undefined;
  status: string;
  totalPrice: string;
  canChange: boolean | null | undefined;
  canCancel: boolean | null | undefined;
}
/**
 * VIEW_TRAVEL_RESERVATION_DETAIL: View reservation detail
 * 
 * @param properties the properties associatied with this event
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.daysTillTripStart: Number of days until the trip starts
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.travelDestination: Destination of the trip
 * @param properties.travelProductTypes: no description
 * @param properties.hotelCrossellDeeplink: no description
 * @param properties.status: Travel Reservation Status
 * @param properties.totalPrice: Sum of the total price of the products minus discounts (markdown and global offers, excluding free delivery or service fee offers).
 * @param properties.canChange: Checks if the reservation has the option to make changes
 * @param properties.canCancel: Checks if the reservation has the option to cancel enabled
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/r9H0K0OEQX}
 */
export function viewTravelReservationDetail(properties: ViewTravelReservationDetailProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "3hllCdILP", name: "DAYS_TILL_TRIP_START", value: properties.daysTillTripStart});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "f6DM5S_j4", name: "TRAVEL_DESTINATION", value: properties.travelDestination});
eventPropertiesArray.push({id: "IgxN_z1PG", name: "TRAVEL_PRODUCT_TYPES", value: properties.travelProductTypes});
properties.hotelCrossellDeeplink !== undefined && properties.hotelCrossellDeeplink !== null ?
  eventPropertiesArray.push({id: "E0tFMhsga", name: "HOTEL_CROSSELL_DEEPLINK", value: properties.hotelCrossellDeeplink}) :
  eventPropertiesArray.push({id: "E0tFMhsga", name: "HOTEL_CROSSELL_DEEPLINK", value: null});
eventPropertiesArray.push({id: "4XUdCeDfht", name: "STATUS", value: properties.status});
eventPropertiesArray.push({id: "T5160UMNzL", name: "TOTAL_PRICE", value: properties.totalPrice});
properties.canChange !== undefined && properties.canChange !== null ?
  eventPropertiesArray.push({id: "AkYO4w7qi", name: "CAN_CHANGE", value: properties.canChange}) :
  eventPropertiesArray.push({id: "AkYO4w7qi", name: "CAN_CHANGE", value: null});
properties.canCancel !== undefined && properties.canCancel !== null ?
  eventPropertiesArray.push({id: "jrqU-IR9z", name: "CAN_CANCEL", value: properties.canCancel}) :
  eventPropertiesArray.push({id: "jrqU-IR9z", name: "CAN_CANCEL", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "r9H0K0OEQX", "2ba39985da0ba3ceaf433133d7eb25f7d72348304c9c123ec992cd7fda75ba8f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_RESERVATION_DETAIL", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("r9H0K0OEQX", "VIEW_TRAVEL_RESERVATION_DETAIL", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_RESERVATION_DETAIL", eventProperties, "r9H0K0OEQX", "2ba39985da0ba3ceaf433133d7eb25f7d72348304c9c123ec992cd7fda75ba8f");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_RESERVATION_DETAIL", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_RESERVATION_DETAIL", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_RESERVATION_DETAIL", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectCancellationBannerProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
}
/**
 * SELECT_CANCELLATION_BANNER: Select cancellation Banner Hotel and Flights
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/5JkvzKYKiq}
 */
export function selectCancellationBanner(properties: SelectCancellationBannerProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "5JkvzKYKiq", "82aba981de0ca1f948f92ce4861e7b17c4ba44f8725780c4e86bdcf00d26de9d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_CANCELLATION_BANNER", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("5JkvzKYKiq", "SELECT_CANCELLATION_BANNER", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_CANCELLATION_BANNER", eventProperties, "5JkvzKYKiq", "82aba981de0ca1f948f92ce4861e7b17c4ba44f8725780c4e86bdcf00d26de9d");
}
// destination Firebase
Firebase.logEvent("SELECT_CANCELLATION_BANNER", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_CANCELLATION_BANNER", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_CANCELLATION_BANNER", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelChangesSearchErrorProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
}
/**
 * TRAVEL_CHANGES_SEARCH_ERROR: When performing a search in Flight Changes and there are no results
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/9LqybhBZM}
 */
export function travelChangesSearchError(properties: TravelChangesSearchErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "9LqybhBZM", "0ef2db2586282090260e042798e0ba7d17def21ca85ef78dd974b092f284daf7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_CHANGES_SEARCH_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("9LqybhBZM", "TRAVEL_CHANGES_SEARCH_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_CHANGES_SEARCH_ERROR", eventProperties, "9LqybhBZM", "0ef2db2586282090260e042798e0ba7d17def21ca85ef78dd974b092f284daf7");
}
// destination Firebase
Firebase.logEvent("TRAVEL_CHANGES_SEARCH_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_CHANGES_SEARCH_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_CHANGES_SEARCH_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewCancellationPageProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
}
/**
 * VIEW_CANCELLATION_PAGE: View cancellation page
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/6EhtuFy40s}
 */
export function viewCancellationPage(properties: ViewCancellationPageProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "6EhtuFy40s", "32faa206273db93d5706a3630a29281c8b427e939667a92c159f8e200da0524a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_CANCELLATION_PAGE", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("6EhtuFy40s", "VIEW_CANCELLATION_PAGE", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_CANCELLATION_PAGE", eventProperties, "6EhtuFy40s", "32faa206273db93d5706a3630a29281c8b427e939667a92c159f8e200da0524a");
}
// destination Firebase
Firebase.logEvent("VIEW_CANCELLATION_PAGE", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_CANCELLATION_PAGE", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_CANCELLATION_PAGE", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelPackageValidationErrorProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
}
/**
 * TRAVEL_PACKAGE_VALIDATION_ERROR: Travel package validation error
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/ehSjZTX6-1}
 */
export function travelPackageValidationError(properties: TravelPackageValidationErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ehSjZTX6-1", "6beafacb4421dfa2638c31f89833b9d6d5a1c54cb6632e23a3cf3242a781783a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_PACKAGE_VALIDATION_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ehSjZTX6-1", "TRAVEL_PACKAGE_VALIDATION_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_PACKAGE_VALIDATION_ERROR", eventProperties, "ehSjZTX6-1", "6beafacb4421dfa2638c31f89833b9d6d5a1c54cb6632e23a3cf3242a781783a");
}
// destination Firebase
Firebase.logEvent("TRAVEL_PACKAGE_VALIDATION_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_PACKAGE_VALIDATION_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_PACKAGE_VALIDATION_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectBannerProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  source: SourceValueType;
  titlePromo: string;
  titleSection: string;
  indexSection: number;
  indexPromo: number;
  typeWidget: string;
}
/**
 * SELECT_BANNER: Click on any item inside Home or Home Item Page from the Travel Store
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.titlePromo: no description
 * @param properties.titleSection: no description
 * @param properties.indexSection: no description
 * @param properties.indexPromo: no description
 * @param properties.typeWidget: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/pnA2DCOdsG}
 */
export function selectBanner(properties: SelectBannerProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "P9QmNopEA", name: "TITLE_PROMO", value: properties.titlePromo});
eventPropertiesArray.push({id: "LWEAS9WYz", name: "TITLE_SECTION", value: properties.titleSection});
eventPropertiesArray.push({id: "2jSWBnS95", name: "INDEX_SECTION", value: properties.indexSection});
eventPropertiesArray.push({id: "pjg1GUgh4", name: "INDEX_PROMO", value: properties.indexPromo});
eventPropertiesArray.push({id: "v5vd7JCAS", name: "TYPE_WIDGET", value: properties.typeWidget});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "pnA2DCOdsG", "813e240d69ca5af699c2a75dc9fa027e964b5969d1e20fce9d20a72f1a98eb6f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_BANNER", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("pnA2DCOdsG", "SELECT_BANNER", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_BANNER", eventProperties, "pnA2DCOdsG", "813e240d69ca5af699c2a75dc9fa027e964b5969d1e20fce9d20a72f1a98eb6f");
}
// destination Firebase
Firebase.logEvent("SELECT_BANNER", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_BANNER", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_BANNER", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelLocationNotFoundProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  searchQuery: string;
  controlId: string;
  travelProductType: string;
}
/**
 * TRAVEL_LOCATION_NOT_FOUND: Triggered when search by query doesn't return any results neither cities nor airports
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.searchQuery: String query value the user put on the input 
 * @param properties.controlId: no description
 * @param properties.travelProductType: Current Travel product
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/2keJPMT_i6}
 */
export function travelLocationNotFound(properties: TravelLocationNotFoundProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "-sj5ZtZVM", name: "SEARCH_QUERY", value: properties.searchQuery});
eventPropertiesArray.push({id: "tgAfgtCS7", name: "CONTROL_ID", value: properties.controlId});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "2keJPMT_i6", "f0c9b279ffa52d98cdad76daccfe7ed69f752eec1dd4d69ef2078a963799a45d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_LOCATION_NOT_FOUND", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("2keJPMT_i6", "TRAVEL_LOCATION_NOT_FOUND", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_LOCATION_NOT_FOUND", eventProperties, "2keJPMT_i6", "f0c9b279ffa52d98cdad76daccfe7ed69f752eec1dd4d69ef2078a963799a45d");
}
// destination Firebase
Firebase.logEvent("TRAVEL_LOCATION_NOT_FOUND", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_LOCATION_NOT_FOUND", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_LOCATION_NOT_FOUND", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CreateTravelAlertProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  customized: boolean;
}
/**
 * CREATE_TRAVEL_ALERT: Click on the Create Alert Button
 * 
 * When to trigger this event:
 * 1. When the user clicks on the Create Alert on the Alert Module
 * View in Avo: https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/aSuXI-Ra0v/trigger/dgnlxDzNb
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.customized: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/aSuXI-Ra0v}
 */
export function createTravelAlert(properties: CreateTravelAlertProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "AACQsuqHr", name: "CUSTOMIZED", value: properties.customized});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "aSuXI-Ra0v", "b53960e776d680904b97ce232238274088918d00e495070c9e8b3f8b29edd564", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("CREATE_TRAVEL_ALERT", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("aSuXI-Ra0v", "CREATE_TRAVEL_ALERT", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("CREATE_TRAVEL_ALERT", eventProperties, "aSuXI-Ra0v", "b53960e776d680904b97ce232238274088918d00e495070c9e8b3f8b29edd564");
}
// destination Firebase
Firebase.logEvent("CREATE_TRAVEL_ALERT", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("CREATE_TRAVEL_ALERT", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("CREATE_TRAVEL_ALERT", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelItemDetailProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  source: SourceValueType;
  index: number;
}
/**
 * VIEW_TRAVEL_ITEM_DETAIL: Triggered when a detail page is opened directly or through a popover. Also when viewing flight details
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.source: Where the event was originated from - here: current context
 * @param properties.index: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/AkIO4KDPKn}
 */
export function viewTravelItemDetail(properties: ViewTravelItemDetailProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "aCFRISX24t", name: "SOURCE", value: properties.source});
eventPropertiesArray.push({id: "GnLP4iwoK", name: "INDEX", value: properties.index});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "AkIO4KDPKn", "210d5650049e4ad4a9bd3de2f2fc268716ae0752859ec49a1efcc4bef1cc3c78", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_ITEM_DETAIL", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("AkIO4KDPKn", "VIEW_TRAVEL_ITEM_DETAIL", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_ITEM_DETAIL", eventProperties, "AkIO4KDPKn", "210d5650049e4ad4a9bd3de2f2fc268716ae0752859ec49a1efcc4bef1cc3c78");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_ITEM_DETAIL", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_ITEM_DETAIL", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_ITEM_DETAIL", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewBookingScreenProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  hasTravellers: boolean;
}
/**
 * VIEW_BOOKING_SCREEN: Triggered when booking page loaded on any Travel Product
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.hasTravellers: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/afZwbyf1Jt}
 */
export function viewBookingScreen(properties: ViewBookingScreenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "HpkLo1Vz8", name: "HAS_TRAVELLERS", value: properties.hasTravellers});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "afZwbyf1Jt", "b71966f0e58f3b1d6081fb52ea0a4c9de32d644b675ac230736730acf0a78fe7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_BOOKING_SCREEN", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("afZwbyf1Jt", "VIEW_BOOKING_SCREEN", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_BOOKING_SCREEN", eventProperties, "afZwbyf1Jt", "b71966f0e58f3b1d6081fb52ea0a4c9de32d644b675ac230736730acf0a78fe7");
}
// destination Firebase
Firebase.logEvent("VIEW_BOOKING_SCREEN", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_BOOKING_SCREEN", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_BOOKING_SCREEN", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelBookingErrorProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  errorMessage: string;
}
/**
 * TRAVEL_BOOKING_ERROR: Triggered when an error occurs when making a payment on the Booking Page
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.errorMessage: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/AH43_vXuCz}
 */
export function travelBookingError(properties: TravelBookingErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "tRHFW4BMQN", name: "ERROR_MESSAGE", value: properties.errorMessage});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "AH43_vXuCz", "9b432cd9d103efe1af664cb0f671bb5c2cbd8073576c4b57ffc193e470f1c2f4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_BOOKING_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("AH43_vXuCz", "TRAVEL_BOOKING_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_BOOKING_ERROR", eventProperties, "AH43_vXuCz", "9b432cd9d103efe1af664cb0f671bb5c2cbd8073576c4b57ffc193e470f1c2f4");
}
// destination Firebase
Firebase.logEvent("TRAVEL_BOOKING_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_BOOKING_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_BOOKING_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelSearchErrorProperties {
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  errorMessage: string;
  travelSegment: string;
  searchFlowType: string;
}
/**
 * TRAVEL_SEARCH_ERROR: Error on search
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.errorMessage: no description
 * @param properties.travelSegment: no description
 * @param properties.searchFlowType: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/qfb-lklE0q}
 */
export function travelSearchError(properties: TravelSearchErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "tRHFW4BMQN", name: "ERROR_MESSAGE", value: properties.errorMessage});
eventPropertiesArray.push({id: "Z3sXe9jj7H-sdZpTLdBAi", name: "TRAVEL_SEGMENT", value: properties.travelSegment});
eventPropertiesArray.push({id: "KE5TAKMZD7z44efMQfh58", name: "SEARCH_FLOW_TYPE", value: properties.searchFlowType});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "qfb-lklE0q", "913d438dbe9f6daf1e2dca80094d91fe3d06c923f20df9b86824cb15457bb5ff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_SEARCH_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("qfb-lklE0q", "TRAVEL_SEARCH_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_SEARCH_ERROR", eventProperties, "qfb-lklE0q", "913d438dbe9f6daf1e2dca80094d91fe3d06c923f20df9b86824cb15457bb5ff");
}
// destination Firebase
Firebase.logEvent("TRAVEL_SEARCH_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_SEARCH_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_SEARCH_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelSeamlessErrorProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  errorMessage: string;
}
/**
 * TRAVEL_SEAMLESS_ERROR: Seamless login error
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.errorMessage: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/jBNlZhh0sP}
 */
export function travelSeamlessError(properties: TravelSeamlessErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "tRHFW4BMQN", name: "ERROR_MESSAGE", value: properties.errorMessage});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "jBNlZhh0sP", "4871c4eb122b233b5ceaddcee69aae157ba061b1f653a80143fa61e4b99356f6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_SEAMLESS_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("jBNlZhh0sP", "TRAVEL_SEAMLESS_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_SEAMLESS_ERROR", eventProperties, "jBNlZhh0sP", "4871c4eb122b233b5ceaddcee69aae157ba061b1f653a80143fa61e4b99356f6");
}
// destination Firebase
Firebase.logEvent("TRAVEL_SEAMLESS_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_SEAMLESS_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_SEAMLESS_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectFlexdatesProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
}
/**
 * SELECT_FLEXDATES: should call it when flex date is selected
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/F-3y2-HDyU}
 */
export function selectFlexdates(properties: SelectFlexdatesProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "F-3y2-HDyU", "ae4d853811e6517f2a54958524551b44d5c5e622f4c955664e68c5b34534286f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_FLEXDATES", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("F-3y2-HDyU", "SELECT_FLEXDATES", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_FLEXDATES", eventProperties, "F-3y2-HDyU", "ae4d853811e6517f2a54958524551b44d5c5e622f4c955664e68c5b34534286f");
}
// destination Firebase
Firebase.logEvent("SELECT_FLEXDATES", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_FLEXDATES", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_FLEXDATES", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewFlexdatesProperties {
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  priceDifference: number;
}
/**
 * VIEW_FLEXDATES: view flexdates is active
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.priceDifference: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/SRnikggY7K}
 */
export function viewFlexdates(properties: ViewFlexdatesProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "I-Zc_ev8_", name: "PRICE_DIFFERENCE", value: properties.priceDifference});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "SRnikggY7K", "4317d3561e0f2a93b7f3457b930ece7f7156da05dcc96c0745aa0453e5063320", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_FLEXDATES", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("SRnikggY7K", "VIEW_FLEXDATES", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_FLEXDATES", eventProperties, "SRnikggY7K", "4317d3561e0f2a93b7f3457b930ece7f7156da05dcc96c0745aa0453e5063320");
}
// destination Firebase
Firebase.logEvent("VIEW_FLEXDATES", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_FLEXDATES", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_FLEXDATES", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectFlexdateOptionProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  priceDifference: number;
  cardType: string;
}
/**
 * SELECT_FLEXDATE_OPTION: flexdate option has been selected
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.priceDifference: no description
 * @param properties.cardType: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/QghrPqt6Tu}
 */
export function selectFlexdateOption(properties: SelectFlexdateOptionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "I-Zc_ev8_", name: "PRICE_DIFFERENCE", value: properties.priceDifference});
eventPropertiesArray.push({id: "7fyD-4vY3", name: "CARD_TYPE", value: properties.cardType});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QghrPqt6Tu", "e49e60e66dae3533dd793dbb3d3b967813babdfa10df4d586b75ddaa70cdc81f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_FLEXDATE_OPTION", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QghrPqt6Tu", "SELECT_FLEXDATE_OPTION", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_FLEXDATE_OPTION", eventProperties, "QghrPqt6Tu", "e49e60e66dae3533dd793dbb3d3b967813babdfa10df4d586b75ddaa70cdc81f");
}
// destination Firebase
Firebase.logEvent("SELECT_FLEXDATE_OPTION", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_FLEXDATE_OPTION", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_FLEXDATE_OPTION", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewPaxFormProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
}
/**
 * VIEW_PAX_FORM: Al mostrar el formulario de ingresar un pasajero
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/khHpZ5TyUN}
 */
export function viewPaxForm(properties: ViewPaxFormProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "khHpZ5TyUN", "3ee90025029ed5ab7e9091814234d0b3d9efb7940e49ee64226e9eab9c489fb0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_PAX_FORM", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("khHpZ5TyUN", "VIEW_PAX_FORM", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_PAX_FORM", eventProperties, "khHpZ5TyUN", "3ee90025029ed5ab7e9091814234d0b3d9efb7940e49ee64226e9eab9c489fb0");
}
// destination Firebase
Firebase.logEvent("VIEW_PAX_FORM", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_PAX_FORM", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_PAX_FORM", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewInvoicingFormProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
}
/**
 * VIEW_INVOICING_FORM: Al mostrar el formulario de ingresar un billing info
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/HDXoS1r3Ll}
 */
export function viewInvoicingForm(properties: ViewInvoicingFormProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "HDXoS1r3Ll", "cc14bf6308498a62e4e91c80e9b7bea28a00899f982502877c38183633c68113", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_INVOICING_FORM", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("HDXoS1r3Ll", "VIEW_INVOICING_FORM", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_INVOICING_FORM", eventProperties, "HDXoS1r3Ll", "cc14bf6308498a62e4e91c80e9b7bea28a00899f982502877c38183633c68113");
}
// destination Firebase
Firebase.logEvent("VIEW_INVOICING_FORM", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_INVOICING_FORM", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_INVOICING_FORM", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectChangesSearchProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  allSegments: boolean;
}
/**
 * SELECT_CHANGES_SEARCH:  Clic al botón “Buscar” en Cambios de Vuelos
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.allSegments: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/eSK_GDqKfx}
 */
export function selectChangesSearch(properties: SelectChangesSearchProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "Fdmf_ywss", name: "ALL_SEGMENTS", value: properties.allSegments});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "eSK_GDqKfx", "85ef7a04e16a4a40ea2cf73b8371a487b3ec12a73295d4346f7df6b849ae0745", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_CHANGES_SEARCH", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("eSK_GDqKfx", "SELECT_CHANGES_SEARCH", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_CHANGES_SEARCH", eventProperties, "eSK_GDqKfx", "85ef7a04e16a4a40ea2cf73b8371a487b3ec12a73295d4346f7df6b849ae0745");
}
// destination Firebase
Firebase.logEvent("SELECT_CHANGES_SEARCH", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_CHANGES_SEARCH", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_CHANGES_SEARCH", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelChangesResultsProperties {
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
}
/**
 * VIEW_TRAVEL_CHANGES_RESULTS:  Mostrar los resultados para cambios
 * 
 * @param properties the properties associatied with this event
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/2aPB5XakXi}
 */
export function viewTravelChangesResults(properties: ViewTravelChangesResultsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "2aPB5XakXi", "36fb4cc37a46623738fd73e512a1965acf471e7850b385c6abaf8b1346d6e56b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_CHANGES_RESULTS", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("2aPB5XakXi", "VIEW_TRAVEL_CHANGES_RESULTS", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_CHANGES_RESULTS", eventProperties, "2aPB5XakXi", "36fb4cc37a46623738fd73e512a1965acf471e7850b385c6abaf8b1346d6e56b");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_CHANGES_RESULTS", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_CHANGES_RESULTS", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_CHANGES_RESULTS", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectChangeOptionProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string | null | undefined;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  itineraryId: number;
  cost: boolean;
}
/**
 * SELECT_CHANGE_OPTION: Al seleccionar un vuelo en Cambios de Vuelos
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.cost: Si el usuario eligio un cambio con costo/ sin costo
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/h6K3FUVls}
 */
export function selectChangeOption(properties: SelectChangeOptionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
properties.city !== undefined && properties.city !== null ?
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city}) :
  eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: null});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
properties.microzoneId !== undefined && properties.microzoneId !== null ?
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId}) :
  eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "BWeBUTnPw", name: "COST", value: properties.cost});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "h6K3FUVls", "b02e40c1621c6f37a5362b1be0572ac889f273dd93840a1f908a3d0dca86ee14", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_CHANGE_OPTION", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("h6K3FUVls", "SELECT_CHANGE_OPTION", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_CHANGE_OPTION", eventProperties, "h6K3FUVls", "b02e40c1621c6f37a5362b1be0572ac889f273dd93840a1f908a3d0dca86ee14");
}
// destination Firebase
Firebase.logEvent("SELECT_CHANGE_OPTION", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_CHANGE_OPTION", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_CHANGE_OPTION", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectViewSeatmapProperties {
  itineraryId: number;
}
/**
 * SELECT_VIEW_SEATMAP: User clicks to view seat map module
 * 
 * @param properties the properties associatied with this event
 * @param properties.itineraryId: Travel Itinerary Id
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/-ggNxAlcW9}
 */
export function selectViewSeatmap(properties: SelectViewSeatmapProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "-ggNxAlcW9", "66b0b627cdfabff047aa1977ca9f8b443f8ba46f86340746bbd6a5669f870601", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_VIEW_SEATMAP", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("-ggNxAlcW9", "SELECT_VIEW_SEATMAP", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_VIEW_SEATMAP", eventProperties, "-ggNxAlcW9", "66b0b627cdfabff047aa1977ca9f8b443f8ba46f86340746bbd6a5669f870601");
}
// destination Firebase
Firebase.logEvent("SELECT_VIEW_SEATMAP", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_VIEW_SEATMAP", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_VIEW_SEATMAP", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewSeatmapErrorProperties {
  itineraryId: number;
  flightIndex: string;
}
/**
 * VIEW_SEATMAP_ERROR: Habia un error al obtener la informacion de seatmap para el vuelvo
 * 
 * @param properties the properties associatied with this event
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.flightIndex: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/0K0wSjV87R}
 */
export function viewSeatmapError(properties: ViewSeatmapErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "gdWv1IzHs", name: "FLIGHT_INDEX", value: properties.flightIndex});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0K0wSjV87R", "d000146967e61fb40838fa48f7802659ae7ede746ebc15fa85c5510bcdb8161e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_SEATMAP_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0K0wSjV87R", "VIEW_SEATMAP_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_SEATMAP_ERROR", eventProperties, "0K0wSjV87R", "d000146967e61fb40838fa48f7802659ae7ede746ebc15fa85c5510bcdb8161e");
}
// destination Firebase
Firebase.logEvent("VIEW_SEATMAP_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_SEATMAP_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_SEATMAP_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewSeatmapFlightProperties {
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  itineraryId: number;
  flightIndex: string;
  availableSeats: string;
}
/**
 * VIEW_SEATMAP_FLIGHT: User views flights seat map
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.flightIndex: no description
 * @param properties.availableSeats: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/O3K65CoQn}
 */
export function viewSeatmapFlight(properties: ViewSeatmapFlightProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "gdWv1IzHs", name: "FLIGHT_INDEX", value: properties.flightIndex});
eventPropertiesArray.push({id: "dfcsJSYf5", name: "AVAILABLE_SEATS", value: properties.availableSeats});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "O3K65CoQn", "375502bd2ebe9d3c78b31b8053754d81ebaceccf7c4aa9670ae87e20f994d0bf", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_SEATMAP_FLIGHT", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("O3K65CoQn", "VIEW_SEATMAP_FLIGHT", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_SEATMAP_FLIGHT", eventProperties, "O3K65CoQn", "375502bd2ebe9d3c78b31b8053754d81ebaceccf7c4aa9670ae87e20f994d0bf");
}
// destination Firebase
Firebase.logEvent("VIEW_SEATMAP_FLIGHT", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_SEATMAP_FLIGHT", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_SEATMAP_FLIGHT", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSeatmapSeatProperties {
  itineraryId: number;
  flightIndex: string;
}
/**
 * SELECT_SEATMAP_SEAT: User made a seat selection
 * 
 * @param properties the properties associatied with this event
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.flightIndex: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/pUUocebum}
 */
export function selectSeatmapSeat(properties: SelectSeatmapSeatProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "gdWv1IzHs", name: "FLIGHT_INDEX", value: properties.flightIndex});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "pUUocebum", "56d990594c9193fe326b72fe08dcb83558f065d6b8358293e41e34026d27ca0e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_SEATMAP_SEAT", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("pUUocebum", "SELECT_SEATMAP_SEAT", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_SEATMAP_SEAT", eventProperties, "pUUocebum", "56d990594c9193fe326b72fe08dcb83558f065d6b8358293e41e34026d27ca0e");
}
// destination Firebase
Firebase.logEvent("SELECT_SEATMAP_SEAT", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_SEATMAP_SEAT", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_SEATMAP_SEAT", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ConfirmSeatmapErrorProperties {
  itineraryId: number;
  flightIndex: string;
  impactedPaxPercent: string;
}
/**
 * CONFIRM_SEATMAP_ERROR: Error when confirming seat selection
 * 
 * @param properties the properties associatied with this event
 * @param properties.itineraryId: Travel Itinerary Id
 * @param properties.flightIndex: no description
 * @param properties.impactedPaxPercent: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/NWtpjzVFrq}
 */
export function confirmSeatmapError(properties: ConfirmSeatmapErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "r0us4RpqU1", name: "ITINERARY_ID", value: properties.itineraryId});
eventPropertiesArray.push({id: "gdWv1IzHs", name: "FLIGHT_INDEX", value: properties.flightIndex});
eventPropertiesArray.push({id: "-3gHdbEVr", name: "IMPACTED_PAX_PERCENT", value: properties.impactedPaxPercent});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "NWtpjzVFrq", "585f843e0f962c73b9a1e1e3a1d2a5c1192e294b3acd8aad5294cc0c6e370d28", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("CONFIRM_SEATMAP_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("NWtpjzVFrq", "CONFIRM_SEATMAP_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("CONFIRM_SEATMAP_ERROR", eventProperties, "NWtpjzVFrq", "585f843e0f962c73b9a1e1e3a1d2a5c1192e294b3acd8aad5294cc0c6e370d28");
}
// destination Firebase
Firebase.logEvent("CONFIRM_SEATMAP_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("CONFIRM_SEATMAP_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("CONFIRM_SEATMAP_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSeatmapSeatRemoveProperties {
  seatRemoved: string;
}
/**
 * SELECT_SEATMAP_SEAT_REMOVE: User remove selected seat
 * 
 * @param properties the properties associatied with this event
 * @param properties.seatRemoved: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/QTpX8WZa-E}
 */
export function selectSeatmapSeatRemove(properties: SelectSeatmapSeatRemoveProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "c8ASkj_bb", name: "SEAT_REMOVED", value: properties.seatRemoved});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QTpX8WZa-E", "7e4c893c5cac642c62e01d9c4a3e70e038a6e04b39ab0d9dc219f5631970ca4f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_SEATMAP_SEAT_REMOVE", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QTpX8WZa-E", "SELECT_SEATMAP_SEAT_REMOVE", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_SEATMAP_SEAT_REMOVE", eventProperties, "QTpX8WZa-E", "7e4c893c5cac642c62e01d9c4a3e70e038a6e04b39ab0d9dc219f5631970ca4f");
}
// destination Firebase
Firebase.logEvent("SELECT_SEATMAP_SEAT_REMOVE", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_SEATMAP_SEAT_REMOVE", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_SEATMAP_SEAT_REMOVE", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSeatmapChangeProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string;
  flightIndex: string;
}
/**
 * SELECT_SEATMAP_CHANGE: User made a seat change
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.flightIndex: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/oI__1O7Z2j}
 */
export function selectSeatmapChange(properties: SelectSeatmapChangeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId});
eventPropertiesArray.push({id: "gdWv1IzHs", name: "FLIGHT_INDEX", value: properties.flightIndex});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "oI__1O7Z2j", "8e4d694bf22af21d362a9729519d142fbc230f7e81f4e387bdd3085412f1f9f3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_SEATMAP_CHANGE", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("oI__1O7Z2j", "SELECT_SEATMAP_CHANGE", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_SEATMAP_CHANGE", eventProperties, "oI__1O7Z2j", "8e4d694bf22af21d362a9729519d142fbc230f7e81f4e387bdd3085412f1f9f3");
}
// destination Firebase
Firebase.logEvent("SELECT_SEATMAP_CHANGE", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_SEATMAP_CHANGE", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_SEATMAP_CHANGE", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewTravelAssistanceModalProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  planCode: string;
  planName: string;
  unitPrice: number;
  vendorName: string;
  travelPlatform: string;
}
/**
 * VIEW_TRAVEL_ASSISTANCE_MODAL: Activated when the reservation assistance modal is opened
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.planCode: no description
 * @param properties.planName: no description
 * @param properties.unitPrice: no description
 * @param properties.vendorName: no description
 * @param properties.travelPlatform: Detects user device platform for Travel, since Travel is a web view, the default platform from Amplitude is always set to web
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/3vZuCptLnR}
 */
export function viewTravelAssistanceModal(properties: ViewTravelAssistanceModalProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "06mHjb--x", name: "PLAN_CODE", value: properties.planCode});
eventPropertiesArray.push({id: "hHG_AJwMj", name: "PLAN_NAME", value: properties.planName});
eventPropertiesArray.push({id: "Nvq76EavC", name: "UNIT_PRICE", value: properties.unitPrice});
eventPropertiesArray.push({id: "o9w-vEjz6", name: "VENDOR_NAME", value: properties.vendorName});
eventPropertiesArray.push({id: "NH57t3cmQ", name: "TRAVEL_PLATFORM", value: properties.travelPlatform});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3vZuCptLnR", "b84ab20ad3697b0bc67443082fadf84961bc9724edcba69cb9450124a1556321", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("VIEW_TRAVEL_ASSISTANCE_MODAL", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3vZuCptLnR", "VIEW_TRAVEL_ASSISTANCE_MODAL", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("VIEW_TRAVEL_ASSISTANCE_MODAL", eventProperties, "3vZuCptLnR", "b84ab20ad3697b0bc67443082fadf84961bc9724edcba69cb9450124a1556321");
}
// destination Firebase
Firebase.logEvent("VIEW_TRAVEL_ASSISTANCE_MODAL", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("VIEW_TRAVEL_ASSISTANCE_MODAL", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("VIEW_TRAVEL_ASSISTANCE_MODAL", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelPaxEnrollmentSuccessProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  travelEmail: string;
}
/**
 * TRAVEL_PAX_ENROLLMENT_SUCCESS: Evento que se ejecuta al momento de hacer un registro exitoso en el formulario de creación de cuenta de Marriott Bonvoy
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.travelEmail: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/UQuEPrrVKH}
 */
export function travelPaxEnrollmentSuccess(properties: TravelPaxEnrollmentSuccessProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "S4a47TWQZ", name: "TRAVEL_EMAIL", value: properties.travelEmail});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "UQuEPrrVKH", "ff31910dd6e1a49c7346d0671cab65191f2e758c0ead2566f2a7c918fb070f12", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_PAX_ENROLLMENT_SUCCESS", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("UQuEPrrVKH", "TRAVEL_PAX_ENROLLMENT_SUCCESS", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_PAX_ENROLLMENT_SUCCESS", eventProperties, "UQuEPrrVKH", "ff31910dd6e1a49c7346d0671cab65191f2e758c0ead2566f2a7c918fb070f12");
}
// destination Firebase
Firebase.logEvent("TRAVEL_PAX_ENROLLMENT_SUCCESS", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_PAX_ENROLLMENT_SUCCESS", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_PAX_ENROLLMENT_SUCCESS", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelPaxEnrollmentErrorProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  travelEmail: string;
  errorMessage: string;
}
/**
 * TRAVEL_PAX_ENROLLMENT_ERROR: Evento que se ejecuta cuando falla la creación de usuario en Marriott Bonvoy
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.travelEmail: no description
 * @param properties.errorMessage: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/Gz-85fYft0}
 */
export function travelPaxEnrollmentError(properties: TravelPaxEnrollmentErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "S4a47TWQZ", name: "TRAVEL_EMAIL", value: properties.travelEmail});
eventPropertiesArray.push({id: "tRHFW4BMQN", name: "ERROR_MESSAGE", value: properties.errorMessage});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Gz-85fYft0", "1c1955f2efde6bd05fe7d1a0c0bc875263bfbcbf050f7f5703f09936cc53069d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_PAX_ENROLLMENT_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Gz-85fYft0", "TRAVEL_PAX_ENROLLMENT_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_PAX_ENROLLMENT_ERROR", eventProperties, "Gz-85fYft0", "1c1955f2efde6bd05fe7d1a0c0bc875263bfbcbf050f7f5703f09936cc53069d");
}
// destination Firebase
Firebase.logEvent("TRAVEL_PAX_ENROLLMENT_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_PAX_ENROLLMENT_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_PAX_ENROLLMENT_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelUpsellOptionsErrorProperties {
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  errorMessage: string;
  searchFlowType: string;
  travelSegment: string;
}
/**
 * TRAVEL_UPSELL_OPTIONS_ERROR: identify when the upsell service has had an error
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.errorMessage: no description
 * @param properties.searchFlowType: no description
 * @param properties.travelSegment: no description
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/jIbBcd-nhG}
 */
export function travelUpsellOptionsError(properties: TravelUpsellOptionsErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "tRHFW4BMQN", name: "ERROR_MESSAGE", value: properties.errorMessage});
eventPropertiesArray.push({id: "KE5TAKMZD7z44efMQfh58", name: "SEARCH_FLOW_TYPE", value: properties.searchFlowType});
eventPropertiesArray.push({id: "Z3sXe9jj7H-sdZpTLdBAi", name: "TRAVEL_SEGMENT", value: properties.travelSegment});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "jIbBcd-nhG", "1825e407715c366a82a503323d54ab7d80072e05ffe29d24546dc61269b67e07", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_UPSELL_OPTIONS_ERROR", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("jIbBcd-nhG", "TRAVEL_UPSELL_OPTIONS_ERROR", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_UPSELL_OPTIONS_ERROR", eventProperties, "jIbBcd-nhG", "1825e407715c366a82a503323d54ab7d80072e05ffe29d24546dc61269b67e07");
}
// destination Firebase
Firebase.logEvent("TRAVEL_UPSELL_OPTIONS_ERROR", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_UPSELL_OPTIONS_ERROR", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_UPSELL_OPTIONS_ERROR", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectUpsellOptionsProperties {
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  travelProductCode: string;
  travelProductName: string;
  travelSubProduct: string | null | undefined;
  travelProductCategory: string | null | undefined;
  travelProductPrice: number | null | undefined;
  travelProductProvider: string;
  travelHasMemberRate: boolean | null | undefined;
  travelTotalPrice: number | null | undefined;
  addressId: number;
  addressDescription: string | null | undefined;
  addressTag: string | null | undefined;
  city: string;
  country: string;
  microzoneName: string | null | undefined;
  microzoneId: string;
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  storeType: string | null | undefined;
  storeId: string;
  storeName: string | null | undefined;
  verticalGroup: string | null | undefined;
  verticalSubGroup: string | null | undefined;
}
/**
 * SELECT_UPSELL_OPTIONS: Dispatch this event only if the UpsellService is called
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.travelProductCode: no description
 * @param properties.travelProductName: no description
 * @param properties.travelSubProduct: no description
 * @param properties.travelProductCategory: no description
 * @param properties.travelProductPrice: no description
 * @param properties.travelProductProvider: no description
 * @param properties.travelHasMemberRate: Checks if the user has Member Rate enabled either by being Prime or having RappiCard
 * @param properties.travelTotalPrice: no description
 * @param properties.addressId: The current address id of the user
 * @param properties.addressDescription: Description of the current address of the user
 * @param properties.addressTag: Tag of the current address of the user
 * @param properties.city: City of the current address of the user
 * @param properties.country: Country of the users current address
 * @param properties.microzoneName: Microzone name of the current user's address
 * @param properties.microzoneId: Id of the current user's address microzone
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.storeType: Type of the store. Ex: market, farmacia, express
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.storeName: Store name value
 * @param properties.verticalGroup: The store vertical group
 * @param properties.verticalSubGroup: The store vertical sub-group
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/8yziLsmWtv}
 */
export function selectUpsellOptions(properties: SelectUpsellOptionsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "GOiDhEob3", name: "TRAVEL_PRODUCT_CODE", value: properties.travelProductCode});
eventPropertiesArray.push({id: "Zy3z-dWZJ", name: "TRAVEL_PRODUCT_NAME", value: properties.travelProductName});
properties.travelSubProduct !== undefined && properties.travelSubProduct !== null ?
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: properties.travelSubProduct}) :
  eventPropertiesArray.push({id: "u_mnvQW8u", name: "TRAVEL_SUB_PRODUCT", value: null});
properties.travelProductCategory !== undefined && properties.travelProductCategory !== null ?
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: properties.travelProductCategory}) :
  eventPropertiesArray.push({id: "2cDIC8OLo", name: "TRAVEL_PRODUCT_CATEGORY", value: null});
properties.travelProductPrice !== undefined && properties.travelProductPrice !== null ?
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: properties.travelProductPrice}) :
  eventPropertiesArray.push({id: "YYnoWf8XT", name: "TRAVEL_PRODUCT_PRICE", value: null});
eventPropertiesArray.push({id: "stal3RsZR", name: "TRAVEL_PRODUCT_PROVIDER", value: properties.travelProductProvider});
properties.travelHasMemberRate !== undefined && properties.travelHasMemberRate !== null ?
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: properties.travelHasMemberRate}) :
  eventPropertiesArray.push({id: "lfVj2l5Vt", name: "TRAVEL_HAS_MEMBER_RATE", value: null});
properties.travelTotalPrice !== undefined && properties.travelTotalPrice !== null ?
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: properties.travelTotalPrice}) :
  eventPropertiesArray.push({id: "JOASmUXs2", name: "TRAVEL_TOTAL_PRICE", value: null});
eventPropertiesArray.push({id: "-i28XxS4ci", name: "ADDRESS_ID", value: properties.addressId});
properties.addressDescription !== undefined && properties.addressDescription !== null ?
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: properties.addressDescription}) :
  eventPropertiesArray.push({id: "bBO1NVdciZ", name: "ADDRESS_DESCRIPTION", value: null});
properties.addressTag !== undefined && properties.addressTag !== null ?
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: properties.addressTag}) :
  eventPropertiesArray.push({id: "6QCeFKOjzc", name: "ADDRESS_TAG", value: null});
eventPropertiesArray.push({id: "iLdYtS_nGN", name: "CITY", value: properties.city});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
properties.microzoneName !== undefined && properties.microzoneName !== null ?
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: properties.microzoneName}) :
  eventPropertiesArray.push({id: "0riyC-HzFW", name: "MICROZONE_NAME", value: null});
eventPropertiesArray.push({id: "LOaymqLuzG", name: "MICROZONE_ID", value: properties.microzoneId});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
properties.storeType !== undefined && properties.storeType !== null ?
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: properties.storeType}) :
  eventPropertiesArray.push({id: "Kz6IYzwGII", name: "STORE_TYPE", value: null});
eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId});
properties.storeName !== undefined && properties.storeName !== null ?
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: properties.storeName}) :
  eventPropertiesArray.push({id: "Y2MNwr0j3V", name: "STORE_NAME", value: null});
properties.verticalGroup !== undefined && properties.verticalGroup !== null ?
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: properties.verticalGroup}) :
  eventPropertiesArray.push({id: "kIFVSYSZhE", name: "VERTICAL_GROUP", value: null});
properties.verticalSubGroup !== undefined && properties.verticalSubGroup !== null ?
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: properties.verticalSubGroup}) :
  eventPropertiesArray.push({id: "JQyp0m4etS", name: "VERTICAL_SUB_GROUP", value: null});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "8yziLsmWtv", "c6c30622fc8f95eb57e02015f73da1ef3a64962d307dbb645a22fa89d61a825a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_UPSELL_OPTIONS", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("8yziLsmWtv", "SELECT_UPSELL_OPTIONS", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_UPSELL_OPTIONS", eventProperties, "8yziLsmWtv", "c6c30622fc8f95eb57e02015f73da1ef3a64962d307dbb645a22fa89d61a825a");
}
// destination Firebase
Firebase.logEvent("SELECT_UPSELL_OPTIONS", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_UPSELL_OPTIONS", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_UPSELL_OPTIONS", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectTravelAssistanceProperties {
  userId: string;
  isPrime: boolean | null | undefined;
  loyaltyLevel: string | null | undefined;
  travelProductType: string;
  travelFrom: string;
  travelTo: string;
  travelDestinationType: string;
  travelTripType: string | null | undefined;
  travelAdvancedPurchase: string;
  travelDateFrom: string;
  travelDateTo: string;
  travelTripLength: number | null | undefined;
  travelPassengers: number | null | undefined;
  travelAdults: number | null | undefined;
  travelChildren: number | null | undefined;
  travelInfants: number | null | undefined;
  travelClassOfService: string | null | undefined;
  travelRooms: number | null | undefined;
  travelWithBaggage: boolean | null | undefined;
  travelBranchCode: string;
  travelSearchId: string;
  travelHotelDestinationId: string | null | undefined;
  travelHotelDestinationType: string | null | undefined;
  planCode: string;
  planName: string;
  unitPrice: number;
  vendorName: string;
  travelPlatform: string;
}
/**
 * SELECT_TRAVEL_ASSISTANCE: It is registered when the user chooses the option 'Yes, travel protected'
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId: Id of the user
 * @param properties.isPrime: Is the user a prime user?
 * @param properties.loyaltyLevel: Users current loyalty level
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelFrom: no description
 * @param properties.travelTo: no description
 * @param properties.travelDestinationType: no description
 * @param properties.travelTripType: no description
 * @param properties.travelAdvancedPurchase: no description
 * @param properties.travelDateFrom: no description
 * @param properties.travelDateTo: no description
 * @param properties.travelTripLength: no description
 * @param properties.travelPassengers: no description
 * @param properties.travelAdults: no description
 * @param properties.travelChildren: no description
 * @param properties.travelInfants: no description
 * @param properties.travelClassOfService: no description
 * @param properties.travelRooms: no description
 * @param properties.travelWithBaggage: Check if the reservation includes baggage
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.travelSearchId: no description
 * @param properties.travelHotelDestinationId: no description
 * @param properties.travelHotelDestinationType: no description
 * @param properties.planCode: no description
 * @param properties.planName: no description
 * @param properties.unitPrice: no description
 * @param properties.vendorName: no description
 * @param properties.travelPlatform: Detects user device platform for Travel, since Travel is a web view, the default platform from Amplitude is always set to web
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/8UVNbNHSpe}
 */
export function selectTravelAssistance(properties: SelectTravelAssistanceProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
properties.isPrime !== undefined && properties.isPrime !== null ?
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: properties.isPrime}) :
  eventPropertiesArray.push({id: "XMMbRBUoXs", name: "IS_PRIME", value: null});
properties.loyaltyLevel !== undefined && properties.loyaltyLevel !== null ?
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: properties.loyaltyLevel}) :
  eventPropertiesArray.push({id: "AesGrdsI9G", name: "LOYALTY_LEVEL", value: null});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
eventPropertiesArray.push({id: "mqjxmhl_D", name: "TRAVEL_FROM", value: properties.travelFrom});
eventPropertiesArray.push({id: "K05nk7K3a", name: "TRAVEL_TO", value: properties.travelTo});
eventPropertiesArray.push({id: "xPMODd-2N", name: "TRAVEL_DESTINATION_TYPE", value: properties.travelDestinationType});
properties.travelTripType !== undefined && properties.travelTripType !== null ?
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: properties.travelTripType}) :
  eventPropertiesArray.push({id: "Hg2XwSlz6", name: "TRAVEL_TRIP_TYPE", value: null});
eventPropertiesArray.push({id: "LI5TeNdD0", name: "TRAVEL_ADVANCED_PURCHASE", value: properties.travelAdvancedPurchase});
eventPropertiesArray.push({id: "4xTpMyujU", name: "TRAVEL_DATE_FROM", value: properties.travelDateFrom});
eventPropertiesArray.push({id: "ngDxvAfkr", name: "TRAVEL_DATE_TO", value: properties.travelDateTo});
properties.travelTripLength !== undefined && properties.travelTripLength !== null ?
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: properties.travelTripLength}) :
  eventPropertiesArray.push({id: "aftOWaiYM", name: "TRAVEL_TRIP_LENGTH", value: null});
properties.travelPassengers !== undefined && properties.travelPassengers !== null ?
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: properties.travelPassengers}) :
  eventPropertiesArray.push({id: "PpqB05rdX", name: "TRAVEL_PASSENGERS", value: null});
properties.travelAdults !== undefined && properties.travelAdults !== null ?
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: properties.travelAdults}) :
  eventPropertiesArray.push({id: "OSGM2CRjh", name: "TRAVEL_ADULTS", value: null});
properties.travelChildren !== undefined && properties.travelChildren !== null ?
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: properties.travelChildren}) :
  eventPropertiesArray.push({id: "sGm6I8b3C", name: "TRAVEL_CHILDREN", value: null});
properties.travelInfants !== undefined && properties.travelInfants !== null ?
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: properties.travelInfants}) :
  eventPropertiesArray.push({id: "MovBd1IbF", name: "TRAVEL_INFANTS", value: null});
properties.travelClassOfService !== undefined && properties.travelClassOfService !== null ?
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: properties.travelClassOfService}) :
  eventPropertiesArray.push({id: "O2iDJLrEr", name: "TRAVEL_CLASS_OF_SERVICE", value: null});
properties.travelRooms !== undefined && properties.travelRooms !== null ?
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: properties.travelRooms}) :
  eventPropertiesArray.push({id: "QZrwc8QVS", name: "TRAVEL_ROOMS", value: null});
properties.travelWithBaggage !== undefined && properties.travelWithBaggage !== null ?
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: properties.travelWithBaggage}) :
  eventPropertiesArray.push({id: "0eMtOOrZp", name: "TRAVEL_WITH_BAGGAGE", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
eventPropertiesArray.push({id: "Qf9kCC5aG", name: "TRAVEL_SEARCH_ID", value: properties.travelSearchId});
properties.travelHotelDestinationId !== undefined && properties.travelHotelDestinationId !== null ?
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: properties.travelHotelDestinationId}) :
  eventPropertiesArray.push({id: "pIja2bY8k", name: "TRAVEL_HOTEL_DESTINATION_ID", value: null});
properties.travelHotelDestinationType !== undefined && properties.travelHotelDestinationType !== null ?
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: properties.travelHotelDestinationType}) :
  eventPropertiesArray.push({id: "5iB_nm9v9", name: "TRAVEL_HOTEL_DESTINATION_TYPE", value: null});
eventPropertiesArray.push({id: "06mHjb--x", name: "PLAN_CODE", value: properties.planCode});
eventPropertiesArray.push({id: "hHG_AJwMj", name: "PLAN_NAME", value: properties.planName});
eventPropertiesArray.push({id: "Nvq76EavC", name: "UNIT_PRICE", value: properties.unitPrice});
eventPropertiesArray.push({id: "o9w-vEjz6", name: "VENDOR_NAME", value: properties.vendorName});
eventPropertiesArray.push({id: "NH57t3cmQ", name: "TRAVEL_PLATFORM", value: properties.travelPlatform});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "8UVNbNHSpe", "6937a4ffcc8431528a471d548702b75aea2ae1ca80223766c19e793f24a2556a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("SELECT_TRAVEL_ASSISTANCE", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("8UVNbNHSpe", "SELECT_TRAVEL_ASSISTANCE", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("SELECT_TRAVEL_ASSISTANCE", eventProperties, "8UVNbNHSpe", "6937a4ffcc8431528a471d548702b75aea2ae1ca80223766c19e793f24a2556a");
}
// destination Firebase
Firebase.logEvent("SELECT_TRAVEL_ASSISTANCE", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("SELECT_TRAVEL_ASSISTANCE", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("SELECT_TRAVEL_ASSISTANCE", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TravelSessionExpiredProperties {
  travelPlatform: string;
  country: string;
  sessionToken: string;
  authToken: string;
  travelProductType: string;
  travelItineraryId: string | null | undefined;
  storeId: string | null | undefined;
  travelBranchCode: string;
  validateOptionId: string | null | undefined;
  userId: string;
  travelSection: TravelSectionValueType;
}
/**
 * TRAVEL_SESSION_EXPIRED: Activated when the Booking - Book or SummaryBranch service faild
 * 
 * @param properties the properties associatied with this event
 * @param properties.travelPlatform: Detects user device platform for Travel, since Travel is a web view, the default platform from Amplitude is always set to web
 * @param properties.country: Country of the users current address
 * @param properties.sessionToken: Netactica token associated with the client
 * @param properties.authToken: Rappi token associated with the client
 * @param properties.travelProductType: Current Travel product
 * @param properties.travelItineraryId: no description
 * @param properties.storeId: Store ID, if any (grability's store ID).
 * @param properties.travelBranchCode: Branch Code used
 * @param properties.validateOptionId: no description
 * @param properties.userId: Id of the user
 * @param properties.travelSection: When the event is executed
 * 
 * @see {@link https://www.avo.app/schemas/0W1AhQECqKT8Mns7rnbu/branches/Iv9tevMvR/events/xx4xLah2bI}
 */
export function travelSessionExpired(properties: TravelSessionExpiredProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "NH57t3cmQ", name: "TRAVEL_PLATFORM", value: properties.travelPlatform});
eventPropertiesArray.push({id: "Tfx04pLsTL", name: "COUNTRY", value: properties.country});
eventPropertiesArray.push({id: "bSZKDrQqA", name: "SESSION_TOKEN", value: properties.sessionToken});
eventPropertiesArray.push({id: "RaPAPnB8v", name: "AUTH_TOKEN", value: properties.authToken});
eventPropertiesArray.push({id: "5wGtnXYgUX", name: "TRAVEL_PRODUCT_TYPE", value: properties.travelProductType});
properties.travelItineraryId !== undefined && properties.travelItineraryId !== null ?
  eventPropertiesArray.push({id: "-X2f12qJp", name: "TRAVEL_ITINERARY_ID", value: properties.travelItineraryId}) :
  eventPropertiesArray.push({id: "-X2f12qJp", name: "TRAVEL_ITINERARY_ID", value: null});
properties.storeId !== undefined && properties.storeId !== null ?
  eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: properties.storeId}) :
  eventPropertiesArray.push({id: "DsJLfkTvgu", name: "STORE_ID", value: null});
eventPropertiesArray.push({id: "mufFcMU41", name: "TRAVEL_BRANCH_CODE", value: properties.travelBranchCode});
properties.validateOptionId !== undefined && properties.validateOptionId !== null ?
  eventPropertiesArray.push({id: "kHw4XVuWt", name: "VALIDATE_OPTION_ID", value: properties.validateOptionId}) :
  eventPropertiesArray.push({id: "kHw4XVuWt", name: "VALIDATE_OPTION_ID", value: null});
eventPropertiesArray.push({id: "Et0qgmClUj", name: "USER_ID", value: properties.userId});
eventPropertiesArray.push({id: "O1nQN1cJX", name: "TRAVEL_SECTION", value: properties.travelSection});
eventPropertiesArray.push({id: "yIWGHi1JsV", name: "APP_VERSION", value: sysAppVersion});
eventPropertiesArray.push({id: "df6Se-jhHg", name: "APP_ENVIRONMENT", value: sysAppEnvironment});
eventPropertiesArray.push({id: "HfDZ3TaH97", name: "STORE_PLATFORM", value: sysStorePlatform});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "xx4xLah2bI", "5f09f742e03cded27fd7c6d49cbae895adcd2a2736ed8b8a02dae75252196be7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("TRAVEL_SESSION_EXPIRED", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("xx4xLah2bI", "TRAVEL_SESSION_EXPIRED", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TRAVEL_SESSION_EXPIRED", eventProperties, "xx4xLah2bI", "5f09f742e03cded27fd7c6d49cbae895adcd2a2736ed8b8a02dae75252196be7");
}
// destination Firebase
Firebase.logEvent("TRAVEL_SESSION_EXPIRED", (Object as any).assign({}, eventProperties));

// destination Braze
Braze.logEvent("TRAVEL_SESSION_EXPIRED", (Object as any).assign({}, eventProperties));

// destination Amplitude
Amplitude.logEvent("TRAVEL_SESSION_EXPIRED", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  StorePlatform,
  TravelSection,
  Source,
  AppEnvironment,
  viewTravelHome,
  viewTravelPage,
  viewTravelSearchScreen,
  travelOrderConfirmed,
  selectTravelSearch,
  proceedToCheckout,
  selectCancellationConfirm,
  viewTravelResultsScreen,
  viewTravelReservationDetail,
  selectCancellationBanner,
  travelChangesSearchError,
  viewCancellationPage,
  travelPackageValidationError,
  selectBanner,
  travelLocationNotFound,
  createTravelAlert,
  viewTravelItemDetail,
  viewBookingScreen,
  travelBookingError,
  travelSearchError,
  travelSeamlessError,
  selectFlexdates,
  viewFlexdates,
  selectFlexdateOption,
  viewPaxForm,
  viewInvoicingForm,
  selectChangesSearch,
  viewTravelChangesResults,
  selectChangeOption,
  selectViewSeatmap,
  viewSeatmapError,
  viewSeatmapFlight,
  selectSeatmapSeat,
  confirmSeatmapError,
  selectSeatmapSeatRemove,
  selectSeatmapChange,
  viewTravelAssistanceModal,
  travelPaxEnrollmentSuccess,
  travelPaxEnrollmentError,
  travelUpsellOptionsError,
  selectUpsellOptions,
  selectTravelAssistance,
  travelSessionExpired,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["viewTravelHome","viewTravelPage","viewTravelSearchScreen","travelOrderConfirmed","selectTravelSearch","proceedToCheckout","selectCancellationConfirm","viewTravelResultsScreen","viewTravelReservationDetail","selectCancellationBanner","travelChangesSearchError","viewCancellationPage","travelPackageValidationError","selectBanner","travelLocationNotFound","createTravelAlert","viewTravelItemDetail","viewBookingScreen","travelBookingError","travelSearchError","travelSeamlessError","selectFlexdates","viewFlexdates","selectFlexdateOption","viewPaxForm","viewInvoicingForm","selectChangesSearch","viewTravelChangesResults","selectChangeOption","selectViewSeatmap","viewSeatmapError","viewSeatmapFlight","selectSeatmapSeat","confirmSeatmapError","selectSeatmapSeatRemove","selectSeatmapChange","viewTravelAssistanceModal","travelPaxEnrollmentSuccess","travelPaxEnrollmentError","travelUpsellOptionsError","selectUpsellOptions","selectTravelAssistance","travelSessionExpired"]
